(function () {
  if (window.NoendyToast) return;

  const stackId = 'NoendyToastStack';

  function ensureStack() {
    let stack = document.getElementById(stackId);
    if (!stack) {
      stack = document.createElement('div');
      stack.id = stackId;
      stack.className = 'noendy-toast-stack';
      stack.setAttribute('role', 'status');
      stack.setAttribute('aria-live', 'polite');
      document.body.appendChild(stack);
    }
    return stack;
  }

  function iconFor(type) {
    if (type === 'success') return '✓';
    if (type === 'error') return '!';
    return 'i';
  }

  function show({ title, message, type = 'success', duration = 4000 } = {}) {
    const stack = ensureStack();
    const toast = document.createElement('div');
    toast.className = `noendy-toast noendy-toast--${type}`;
    toast.innerHTML = `
      <span class="noendy-toast__icon" aria-hidden="true">${iconFor(type)}</span>
      <div class="noendy-toast__body">
        ${title ? `<p class="noendy-toast__title"></p>` : ''}
        ${message ? `<p class="noendy-toast__message"></p>` : ''}
      </div>
      <button type="button" class="noendy-toast__close" aria-label="Bildirimi kapat">
        <svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor" aria-hidden="true">
          <path d="M9.06 8l3.47-3.47-1.06-1.06L8 6.94 4.53 3.47 3.47 4.53 6.94 8l-3.47 3.47 1.06 1.06L8 9.06l3.47 3.47 1.06-1.06z"/>
        </svg>
      </button>
    `;

    if (title) toast.querySelector('.noendy-toast__title').textContent = title;
    if (message) toast.querySelector('.noendy-toast__message').textContent = message;

    stack.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('is-visible'));

    let timeout = setTimeout(() => dismiss(toast), duration);

    function dismiss(node) {
      node.classList.add('is-leaving');
      setTimeout(() => node.remove(), 300);
    }

    toast.querySelector('.noendy-toast__close').addEventListener('click', () => {
      clearTimeout(timeout);
      dismiss(toast);
    });

    return toast;
  }

  window.NoendyToast = { show };

  document.addEventListener('cart:updated', (e) => {
    const detail = e.detail || {};
    if (detail.silent) return;
    show({
      title: 'Sepete eklendi',
      message: detail.message || 'Ürün sepetine eklendi.',
      type: 'success'
    });
  });
})();
